import { Outlet } from 'react-router';
import { useTrads } from '../contexts/trads/useTrads';
function AuthLayout() {
  const {translate}=useTrads();

  return (
    <>
    <div className="col-12  master authlayout">
      <header></header>
      {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, like navigation. */}


      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <div id="login-content">
        <Outlet />
      </div>
      
    </div>
    <footer>

      {translate('global_footer')}</footer>
    </>
  );
}

export default AuthLayout;